import client from "lib/apolloClient/client";
import {
  getProjectGroupSupervisorsQuery,
  getProjectGroupProjectsQuery,
  getProjectAllocationStatusQuery,
  getProjectGroupProjectsCountQuery,
  getProjectGroupSupervisorsCountQuery,
  getProjectGroupStudentCountQuery,
  getProjectStudentAllocationStatusQuery,
  getProjectSupervisorAndStudentsQuery,
  getProjectGroupPortfoliosStudentStaffQuery,
  getProjectGroupStudentsPoolQuery,
  getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
  getProjectGroupSupervisorsPoolQuery,
  getOrganizationExternalUsersQuery,
  getProjectGroupInternalSupervisorPendingApprovalCountQuery,
  getProjectGroupExternalSupervisorPendingApprovalCountQuery,
  getProjectGroupSupervisorsWithTypeCountQuery,
  getOrganizationStaffQuery,
} from "./InviteQueries";
import {
  projectFragments,
  studentProjectPortfolioFragments,
} from "./InviteFragments";
import { projectGroupSupervisor } from "Projects/modules/ProjectFragments";

export const getProjectGroupSupervisorsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupSupervisorsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupProjectsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupProjectsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getOrganizationStaffFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationStaffQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getProjectAllocationStatusFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectAllocationStatusQuery,
      variables: {
        ...params,
        staffId: 0,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const writeProjectGroupProjectInCache = ({
  projectGroupId,
  projectId,
  data,
}) => {
  try {
    client.writeFragment({
      id: `Project:${projectId}`,
      fragment: projectFragments.projectInfoFragment,
      fragmentName: "projectInfo",
      data: data,
      variables: { projectGroupId },
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const writeStudentProjectPortfolioDetailsFragmentInCache = ({
  id,
  data,
}) => {
  try {
    client.writeFragment({
      id: `StudentProjectPortfolio:${id}`,
      fragment:
        studentProjectPortfolioFragments.studentProjectPortfolioDetailsFragment,
      fragmentName: "portfolioStudentAdvisor",
      data: data,
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const getProjectGroupProjectFromCache = ({ projectId }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Project:${projectId}`,
      fragment: projectFragments.projectInfoFragment,
      fragmentName: "projectInfo",
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getStudentProjectPortfolioDetailsFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `StudentProjectPortfolio:${id}`,
      fragment:
        studentProjectPortfolioFragments.studentProjectPortfolioDetailsFragment,
      fragmentName: "portfolioStudentAdvisor",
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupProjectsCountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupProjectsCountQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupSupervisorsCountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupSupervisorsCountQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupSupervisorsWithTypeCountFromCache = ({
  projectGroupId,
  supervisorFilters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupSupervisorsWithTypeCountQuery,
      variables: {
        projectGroupId,
        supervisorFilters,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupStudentCountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupStudentCountQuery,
      variables,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectStudentAllocationStatusFromCache = ({
  projectGroupId,
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectStudentAllocationStatusQuery,
      variables: {
        projectGroupId,
        filters,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectSupervisorAndStudentsFromCache = ({ projectId }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectSupervisorAndStudentsQuery,
      variables: {
        projectId,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupStudentProjectFragmentFromCache = ({
  id,
  projectFieldFilters,
  fetchFields,
  fetchProjectStudents,
  fetchProjects,
  academicYearId,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Project:${id}`,
      fragment: projectFragments.projectGroupStudentProjectInfo,
      fragmentName: "projectGroupStudentProjectInfoItem",
      variables: {
        id,
        projectFieldFilters,
        fetchFields,
        fetchProjectStudents,
        fetchProjects,
        academicYearId,
      },
    });
  } catch (e) {
    console.warn("could not read", e);
    return {};
  }
  return queryData ? queryData : {};
};

export const writeProjectGroupStudentProjectFragmentInCache = ({
  id,
  projectFieldFilters,
  fetchFields,
  fetchProjectStudents,
  fetchProjects,
  data,
  academicYearId,
}) => {
  let queryData = {};
  try {
    queryData = client.writeFragment({
      id: `Project:${id}`,
      fragment: projectFragments.projectGroupStudentProjectInfo,
      fragmentName: "projectGroupStudentProjectInfoItem",
      data,
      variables: {
        id,
        projectFieldFilters,
        fetchFields,
        fetchProjectStudents,
        fetchProjects,
        academicYearId,
      },
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupStudentPortfolioFragmentFromCache = ({
  id,
  academicYearId,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `StudentProjectPortfolio:${id}`,
      fragment: projectFragments.projectGroupStudentPortfolioInfo,
      fragmentName: "projectGroupStudentPortfolioInfoItem",
      variables: {
        id,
        academicYearId,
      },
    });
  } catch (e) {
    console.warn("could not read", e);
    return {};
  }
  return queryData ? queryData : {};
};

export const writeProjectGroupStudentPortfolioFragmentInCache = ({
  id,
  data,
  academicYearId,
}) => {
  let queryData = {};
  try {
    queryData = client.writeFragment({
      id: `StudentProjectPortfolio:${id}`,
      fragment: projectFragments.projectGroupStudentPortfolioInfo,
      fragmentName: "projectGroupStudentPortfolioInfoItem",
      data,
      variables: {
        id,
        academicYearId,
      },
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupPortfoliosStudentStaffFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupPortfoliosStudentStaffQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  return queryData != null ? queryData : {};
};

export const getProjectGroupStudentsPoolFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupStudentsPoolQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupSupervisorApprovalInfoWithProjectsFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupSupervisorApprovalInfoWithProjectsQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};

export const readProjectGroupSupervisorApprovalStatusFragmentFromCache = ({
  id,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `ProjectGroupSupervisor:${id}`,
      fragment: projectGroupSupervisor.projectGroupSupervisorApprovalInfo,
      fragmentName: "projectGroupSupervisorApprovalInfoItem",
    });
  } catch (e) {
    console.warn("could not read", e);
    return {};
  }
  return queryData ? queryData : {};
};

export const writeProjectGroupSupervisorApprovalStatusInCache = ({
  id,
  data,
}) => {
  let queryData = {};
  try {
    queryData = client.writeFragment({
      id: `ProjectGroupSupervisor:${id}`,
      fragment: projectGroupSupervisor.projectGroupSupervisorApprovalInfo,
      fragmentName: "projectGroupSupervisorApprovalInfoItem",
      data,
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getProjectGroupInternalSupervisorPendingApprovalCountFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupInternalSupervisorPendingApprovalCountQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
  }
  return queryData ? queryData : {};
};

export const getProjectGroupExternalSupervisorPendingApprovalCountFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupExternalSupervisorPendingApprovalCountQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
  }
  return queryData ? queryData : {};
};

export const getProjectGroupSupervisorsPoolFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProjectGroupSupervisorsPoolQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getOrganizationExternalUsersFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationExternalUsersQuery,
      variables: params,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};
